import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ExportType } from '@app/shared/+state/metrics';

export interface ExportMetricsDialogPayload {
  includeKPIs: boolean;
  exportType: ExportType;
}

@Component({
  selector: 'hospitable-export-metrics-dialog',
  templateUrl: './export-metrics-dialog.component.html',
  styleUrls: ['./export-metrics-dialog.component.scss'],
})
export class ExportMetricsDialogComponent implements OnInit {
  exportType: ExportType = ExportType.Single;
  rowCount: number;
  email: string;
  includeKPIs = true;
  ExportType = ExportType;
  shouldHideIncludeKPIs = false;

  @Output() exportTypeUpdated: EventEmitter<ExportType> = new EventEmitter();
  @Output() dialogClosed: EventEmitter<ExportMetricsDialogPayload> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<ExportMetricsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  ngOnInit() {
    if (this.dialogData) {
      const { rowCount, email, shouldHideIncludeKPIs } = this.dialogData;
      // this.rowCount = rowCount;
      rowCount.subscribe((rowCount: any) => {
        this.rowCount = rowCount?.data?.count ?? rowCount;
      });
      this.email = email;

      if (shouldHideIncludeKPIs) {
        this.shouldHideIncludeKPIs = shouldHideIncludeKPIs;
      }
    }
  }

  updateExportType(exportType: ExportType) {
    this.exportType = exportType;
    this.exportTypeUpdated.emit(exportType);
  }

  closeDialog() {
    this.dialogClosed.emit({
      includeKPIs: this.shouldHideIncludeKPIs ? false : this.includeKPIs,
      exportType: this.exportType,
    });
    this.dialogRef.close();
  }
}
